<template>
  <div class="in-progress-card">
    <div class="in-progress-card__box">
      <div class="d-flex align-items-center justify-content-between">
        <button class="in-progress-card__play" @click="launchClickUrl('_blank', recording)" :title="$t('sessions.viewrecording')">
          <i class="isax isax-play"></i>
        </button>
        <div class="in-progress-card__date">
          <i class="isax isax-calendar-1 mr-1"/>
          <span>{{ recording.startTime | moment("D MMM YYYY") }}</span>
        </div>
        <b-dropdown dropleft menu-class="button-list-icons small-icons"
                    variant=" icon-button recording-row-options list-item-icon has-tooltip d-flex align-items-center"
                    toggle-class="text-decoration-none" no-caret>
          <template :id="'recording-options-' + recording.id" #button-content>
            <dots-horizontal-icon :size="24"/>
            <b-tooltip :target="'recording-options-' + recording.id" triggers="hover">
              {{ $t("sessions.options") }}
            </b-tooltip>
          </template>
          <b-dropdown-item-btn @click="markAsViewed" link-class="button">
            <span>{{ $t("sessions.markrecordingviewedoption") }}</span>
          </b-dropdown-item-btn>
          <b-dropdown-item-btn @click="removeFromInProgress" link-class="button">
            <span>{{ $t("sessions.removefromkeepwatching") }}</span>
          </b-dropdown-item-btn>
        </b-dropdown>
      </div>
      <div class="in-progress-card__banner mt-auto">
        <div class="sessions-banner sessions-orange-banner mr-1">
          <i class="isax isax-clock mr-1"></i>
          <span v-html="$t('sessions.remainingminutes', { min: remainingMinutes(recording) })"></span>
        </div>
      </div>
      <div class="in-progress-card__title">{{ recording.name }}</div>
    </div>
    <div class="in-progress-card__progress">
      <div class="in-progress-card__progress-bar" :style="{ width: (recording.percentage || 0) + '%' }"></div>
    </div>
  </div>
</template>

<script>
import DotsHorizontalIcon from 'vue-material-design-icons/DotsHorizontal.vue'
import LoadingIcon from 'vue-material-design-icons/Loading.vue'
import jwtMixin from '../../../mixins/jwtMixin'
import recordingPlaybackMixin from '../../../mixins/recordingPlaybackMixin'

export default {
  name: 'InProgressRecordingCard',
  components: { DotsHorizontalIcon, LoadingIcon },
  mixins: [jwtMixin, recordingPlaybackMixin],
  props: {
    recording: { type: Object, required: true }
  },
  methods: {
    removeFromInProgress () {
      const userId = this.jwtLoggedUserId()
      window.axios.patch('recordings/' + this.recording.id + '/user/' + userId, {
        recordingId: this.recording.id,
        userId,
        playing: false
      })
      this.$emit('removed', this.recording.id)
    },
    markAsViewed () {
      const userId = this.jwtLoggedUserId()
      window.axios.patch('recordings/' + this.recording.id + '/user/' + userId, {
        recordingId: this.recording.id,
        userId,
        viewed: true,
        playing: false
      })
      this.$emit('viewed', this.recording.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/SessionsComponents/InProgressRecordingCard.vue